import { createContext, useContext } from 'react';

export interface TenantContextData {
  company: {
    displayName: string;
    legalName: string;
    logoUrl: string | null;
    primaryColor: string;
    secondaryColor: string;
  };
  modules: string[];
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    jobTitle: string | null;
    locale: 'hr-HR' | 'en-US' | 'de-DE';
    permissions: string[];
    dataScope: string;
  };
}

export interface TenantAppContextValue {
  context: TenantContextData;
  modules: Set<string>;
  unread: number;
  refreshUnread: () => Promise<void>;
  updateCurrentUser: (patch: Partial<TenantContextData['user']>) => void;
}

export const TenantAppContext = createContext<TenantAppContextValue | null>(null);

export function useTenantApp(): TenantAppContextValue {
  const context = useContext(TenantAppContext);
  if (!context) throw new Error('TenantAppContext nedostaje.');
  return context;
}
